export const CtaBanner = ({ message }) => {
  return <div className="cta-banner">{message}</div>;
};
